import { useSelector } from "@shared/hooks/shared/useTypedSelector";

export const useUi = () => {
  return useSelector(({ userInterface }: TRootState) => userInterface);
};

export const useMenuPosition = () => {
  return useSelector(
    ({ userInterface }: TRootState) => userInterface.menuPosition
  );
};
